export default __webpack_public_path__ + "static/media/6.c1195151.jpg";